import moment from 'moment';

export const CURRENT_YEAR = moment().year();

export const PRIOR_YEAR = moment().subtract(1, 'year').year();

export const YEAR_OPTIONS = [
  {
    label: PRIOR_YEAR,
    value: PRIOR_YEAR.toString()
  },
  {
    label: CURRENT_YEAR,
    value: CURRENT_YEAR.toString()
  }
];
